module.exports = __webpack_public_path__ + "img/colour-tomato.cf49ada1.png";